import * as yup from 'yup';

export const getPasswordSchema = (translate: (key: string, options?: any) => string) =>
    yup
        .string()
        .required(translate('required'))
        .min(8, translate('password', {length: 8}))
        .max(20, translate('password_max', {length: 20}))
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/,
            translate('invalid_password'),
        );
